// extracted by mini-css-extract-plugin
export default {"catalogByServiceItem":"c-l_eZ","catalogByServiceItem__title":"c-l_fa"};